export const FETCH_RESULT_TEST = "@RESULT/FETCH_RESULT_TEST";

export const actionCreators = {
  fetchResult: () => ({
    type: FETCH_RESULT_TEST,
  }),
};
